"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitMessage = void 0;
var generateGUID_1 = require("@wix/cashier-common/dist/src/utils/guid/generateGUID");
var window_1 = require("../window");
var maxResponseTimeout = 5000;
var maxSlowMessageResponseTimeout = 30000;
exports.emitMessage = function (payload, targetWindow, targetOrigin, isSlowMessage) {
    if (isSlowMessage === void 0) { isSlowMessage = false; }
    return new Promise(function (resolve, reject) {
        var messageId = generateGUID_1.generateGUID();
        var handlePostMessage = function (event) {
            var _a;
            if (event.source &&
                event.origin &&
                event.source === targetWindow &&
                event.origin === targetOrigin &&
                event.data &&
                event.data.messageId === messageId) {
                clearTimeout(waitId);
                if ((_a = event.data.payload) === null || _a === void 0 ? void 0 : _a.error) {
                    reject(event.data.payload.error);
                }
                else {
                    resolve(event.data.payload);
                }
                window_1.win.removeEventListener('message', handlePostMessage);
            }
        };
        var waitId = setTimeout(function () {
            window_1.win.removeEventListener('message', handlePostMessage);
            reject({
                message: "timeout" /* Timeout */,
            });
        }, isSlowMessage ? maxSlowMessageResponseTimeout : maxResponseTimeout);
        window_1.win.addEventListener('message', handlePostMessage);
        targetWindow.postMessage({
            messageId: messageId,
            payload: payload,
        }, targetOrigin);
    });
};
//# sourceMappingURL=emitMessage.js.map